import React from 'react';
import NewHireCoachingReport from './new-hire-coaching-report';
import CandidateProfile from './candidate-profile';
import NewHireManagerReport from './new-hire-manager-report';
import NewHireDevelopmentReport from './new-hire-development-report';
import CandidateDevelopmentReport from './candidate-development-report';
import { isStaffingCandidate } from '../../api/dashboards-api';
import { REPORT_TYPE } from '../../utils/constants';

export const NEW_HIRE_COACHING = 10;
export const NEW_HIRE_DEVELOPMENT = 11;
export const NEW_HIRE_MANAGER = 12;
export const CANDIDATE_DEVELOPMENT = 13;
export const CANDIDATE_PROFILE = 14;

function CandidateReports({ reportSelection, candidate, creatingPdf }) {
  const reportType = isStaffingCandidate(candidate) ? REPORT_TYPE.staffing : REPORT_TYPE.coaching;
  return (
    <>
      {reportSelection === NEW_HIRE_COACHING && (
        <NewHireCoachingReport candidate={candidate} creatingPdf={creatingPdf} reportType={reportType} />
      )}
      {reportSelection === NEW_HIRE_MANAGER && (
        <NewHireManagerReport candidate={candidate} creatingPdf={creatingPdf} reportType={reportType} />
      )}
      {reportSelection === NEW_HIRE_DEVELOPMENT && (
        <NewHireDevelopmentReport candidate={candidate} creatingfPdf={creatingPdf} />
      )}
      {reportSelection === CANDIDATE_PROFILE && <CandidateProfile candidate={candidate} reportType={reportType} />}
      {reportSelection === CANDIDATE_DEVELOPMENT && <CandidateDevelopmentReport candidate={candidate} />}
    </>
  );
}

export default CandidateReports;
